import { Card, Col, Container, Row } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { GalleryGridWithDescriptions, GalleryTitle, MasonryGalleryDescriptionCap } from "../../../Constant";
import { Breadcrumbs } from "../../../AbstractElements";
import { MasonryGalleryWithDescriptionCardBody } from "./MasonryGalleryWithDescriptionCardBody";

const MasonryGalleryWithDescriptionContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={GalleryGridWithDescriptions} parent={GalleryTitle} title={GalleryGridWithDescriptions} />
      <Container fluid>
        <Row>
          <Col sm="12" className="box-col-12">
            <Card>
              <CommonCardHeader title={MasonryGalleryDescriptionCap} />
              <MasonryGalleryWithDescriptionCardBody />
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default MasonryGalleryWithDescriptionContainer;
